import { useQuery } from "@tanstack/react-query";

import { get } from "@/api";
import { queryClient } from "@/pages/Root";

export const CURRENT_ORDER_QUERY_KEY = ["/orders/current/details"] as const;

export function useCurrentOrderDetails(options = {}) {
  return useQuery({
    queryKey: CURRENT_ORDER_QUERY_KEY,
    queryFn: async () => {
      try {
        return await get("/orders/current/details");
      } catch (error) {
        console.error("Failed to fetch order details:", error);
        return null;
      }
    },

    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,

    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    retry: 1,
    ...options,
  });
}

export function invalidateCurrentOrderDetails() {
  return queryClient.invalidateQueries({
    queryKey: CURRENT_ORDER_QUERY_KEY,
  });
}
